import { Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { SharedServiceService } from '../shared-service.service';
import { Application } from 'src/app/applications/application/application';
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
  selector: 'app-accept-offer',
  templateUrl: './accept-offer.component.html',
  styleUrls: ['./accept-offer.component.scss']
})
export class AcceptOfferComponent implements OnInit {
submitted: boolean = false;
checked: boolean = false;
application: Application;
offer:string

  constructor(private matSnackBar: MatSnackBar, public activeModal: NgbActiveModal, private sharedService: SharedServiceService) { }

  ngOnInit(): void {
    this.sharedService.data$.subscribe(data => {
    if (data) {
      this.application = data;
    }
  });
  }

  closeModal() {
    this.activeModal.close();
  }
  

  onSubmit() {
    this.submitted = true;
    if (!this.checked) {
      this.matSnackBar.open('You must accept the offer first before submitting your confirmation', 'Close', { duration: 10000 ,verticalPosition: 'top', horizontalPosition: 'center' });
      return;
    }

    if(this.application.fundingBucket === 'BURSARY') {
      this.offer = 'Loan';
    } else if(this.application.fundingBucket === 'LOAN') {
      this.offer = 'Bursary';
    } else {
      this.matSnackBar.open('Invalid offer type. Please contact support.', 'Close', { duration: 10000 ,verticalPosition: 'top', horizontalPosition: 'center' });
      return;
    }

    this.sharedService.acceptOffer(this.application.id, this.application.fundingBucket).subscribe(response => {
      this.activeModal.close('accepted');
      this.matSnackBar.open(this.offer + ' Offer accepted successfully', 'Close', { duration: 10000,verticalPosition: 'top', horizontalPosition: 'center' });
    }, error => {
      this.matSnackBar.open('Error accepting offer. Please try again later.\n'+error, 'Close', { duration: 10000 ,verticalPosition: 'top', horizontalPosition: 'center' });
    });
  }

}
